// extracted by mini-css-extract-plugin
export var bookingsModalHolder = "BookingsModal-module--bookingsModalHolder--674cc";